import React, {
  useContext,
  useEffect,
  useState,
  useCallback,
  useRef,
} from "react";
import { Typography, Grid, TextField, Button, Box, Dialog, DialogContent, DialogActions, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@material-ui/core";
import GetIdeasIcon from "../../assets/images/icon/getIdeas";
import palette from "../../theme/palette";
import IdeasDrawer from "./IdeasDrawer";
// import CategoryItem from "./CategoryItem";
import { categoryService } from "../../services/category";
import { UserTypeContext } from "../../context/userStatus";
import { TrackingContext } from "../../context/userTracking";
import { setOpenSubscriptionModal } from "../../store/actions/userTypeAction";
import SnackBarComp from "../../components/snackBar";
import { ButtonLoader } from "../../components/buttonLoader";
import { CategoryUpdate } from "../../interfaces/categoryModel";
import { OutcomesList } from "./AddCategoryIndex";
// import { useDrag, useDrop } from 'react-dnd';
import CategoryItemWrapper from "./CategoryItem";
import { pxToRem } from "../../theme/typography";
import NewButton from "../../components/NewButton";
import useWidth from "../../utils/useWidth";
import CommonTypo from "../../components/CommonTypo";

const RootStyle = styled("div")(({ theme }) => ({
  padding: "50px 48px 50px 80px",
  position: "relative",
  overflowY: "scroll",
  height: "100vh",
  [theme.breakpoints.down("xl")]: {
    padding: "50px 40px 50px 60px",
  },
  [theme.breakpoints.down("md")]: {
    padding: "40px 20px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "20px",
  },
}));

const useStyles = makeStyles((theme) => ({
  registrationHeading: {
    color: palette.primary.light,
    lineHeight: "120%!important",
  },
  pageTitle: {
    marginTop: "40px!important",
    marginBottom: "84px!important",
    [theme.breakpoints.down("lg")]: {
      marginTop: "40px!important",
      marginBottom: "84px!important",
    },
    [theme.breakpoints.down("md")]: {
      marginTop: "20px!important",
      marginBottom: "28px!important",
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "15px!important",
      marginBottom: "20px!important",
    },
  },
  needSomeIdeas: {
    fontSize: "16px",
    lineHeight: "16px",
    color: "var(--color-new-text)",
    marginLeft: "8px",
    [theme.breakpoints.down("md")]: {
      marginTop: "10px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      lineHeight: "14px",
    },
  },
  compactExpandColumntab: {
    color: palette.primary.light,
    lineHeight: "150%!important",
    fontSize: `${pxToRem(16)} !important`,
  },
  categoryDialog: {
    "& .MuiDialog-container": {
      "& .MuiPaper-root": {
        borderRadius: "24px",
        padding: "0",
        display: "flex",
        // width: '400px',
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",

        "& .MuiDialogContent-root": {
          padding: "0",
          overflowY: "unset",
        },

        "&. MuiDialogActions-root": {},
        "@media  (max-width: 5000px) and (min-width: 100px)": {
          margin: '0px 0px',
          overflow: 'hidden'
        },
      },
    },
  },
  paddingClassMobile: {
    padding: "32px 32px 0px 32px !important",
    "@media  (max-width: 5000px) and (min-width: 100px)": {
      padding: "0px !important",
    },
  },
  categoryDialogAction: {
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: "center !important",
    gap: "12px",
    alignSelf: "stretch !important",
    padding: "32px !important",
    borderTop: `1px solid #F3F3F3`,
    "@media  (max-width: 5000px) and (min-width: 100px)": {
      borderTop: `none`,
      flexDirection: "column",
      padding: "0px !important"
    },
  },
}));

interface LeftSideCategoryModel {
  categoryIdeas: any;
  handleFinish: (finalData: CategoryUpdate[]) => void;
  outcomesList: OutcomesList;
  handleOutcomeListRemove: any;
  handleOutcomeListAdd: any;
  setIsApiCall?: any;
  isApiCall: any;
  addCategoryList: any;
  setAddCategoryList: any;
  expandedList: any;
  setExpandList: any;
  expanded: any;
  setEpanded: any;
}

const LeftSideCategory = (props: LeftSideCategoryModel) => {
  const classes = useStyles();
  const { expandedList, setExpandList, expanded, setEpanded } = props;
  const { state: outcomeState, dispatch: userTypeDispatch } =
    useContext(UserTypeContext);
  const { dispatch: trackingDispatch } = useContext(TrackingContext);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [categoryInput, setCategoryInput] = useState("");
  const { addCategoryList, setAddCategoryList } = props;
  const [showSnakbar, setShowSnakbar] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  // const [expandedView, setexpandedView] = useState(false)
  const [snakbarMsg, setSnakbarMsg] = useState("");
  const [msgType, setMsgType] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const setexpandedView = setEpanded;
  const isDarkMode = useTheme().palette.mode === "dark" || outcomeState.isDarkMode
  const expandedView = expanded;
  // console.log("addCategoryList =====>",addCategoryList)
  const width = useWidth()
  const isMobile = width < 768
  useEffect(() => {
    setOpenDrawer(false);
    if (outcomeState.categoryList) {
      // const newArray = outcomeState.categoryList?.map((item, index) => {
      //   return {
      //     ...item,
      //     arrayIndex: index
      //   }
      // })
      setAddCategoryList(outcomeState.categoryList);
      localStorage.setItem(
        "categoryCount",
        `${outcomeState.categoryList.length}`
      );
    }
  }, [outcomeState.categoryList]);

  const showDrawer = () => {
    setOpenDrawer(true);
  };

  const closeDrawer = () => {
    setOpenDrawer(false);
  };

  const handleCloseSnakbar = () => {
    setShowSnakbar(false);
  };

  const handleChangeCategory = (e: any) => {
    setCategoryInput(e.target.value);
  };

  const handleCreate = () => {
    setShowLoader(true);
    const body = {
      name: categoryInput,
      outcomeIds: [],
      reflectiveIds: [],
      order: addCategoryList?.length + 1,
      influenceIds: [],
      allId: [],
    };
    categoryService
      .createCategory(outcomeState.token, body)
      .then((response) => {
        response.data.arrayIndex = addCategoryList.length;
        setCategoryInput("");
        setAddCategoryList((prevState) => [
          ...prevState,
          {
            ...response.data,
            outcomes: [],
            influences: [],
            reflectives: [],
            alls: [],
          },
        ]);
        setCategoryInput("");
        setShowLoader(false);
        setSnakbarMsg(response.message);
      })
      .catch((error) => {
        setShowLoader(false);
        setShowSnakbar(true);
        setSnakbarMsg(
          error?.response?.data?.description
            ? error?.response?.data?.description
            : error.message
        );
        setMsgType("error");
        console.log("Add category error", error);
      });
  };

  const handleAdd = (categoryId, item) => {
    let arr = [...addCategoryList];
    const index = arr.findIndex(
      (category) => category.categoryId === categoryId
    );

    if (item.outcomeId && !arr[index].outcomeIds.includes(item.outcomeId)) {
      // arr[index].outcomeIds.push(item.outcomeId);
      arr[index].outcomeIds = [...arr[index].outcomeIds, item.outcomeId];
      // arr[index].outcomes.push(item);
      arr[index].outcomes = [...arr[index].outcomes, item];
      // arr[index].allIds.push(item.outcomeId);
      arr[index].allIds = arr[index].allIds
        ? [...arr[index].allIds, item.outcomeId]
        : [item.outcomeId];
      // arr[index].alls.push(item);
      arr[index].alls = arr[index].alls ? [...arr[index].alls, item] : [item];
      props.handleOutcomeListRemove("OUTCOME", item._id);
    } else if (
      item.influenceId &&
      !arr[index].influenceIds.includes(item.influenceId)
    ) {
      arr[index].influenceIds.push(item.influenceId);
      arr[index].influences.push(item);
      arr[index].allIds.push(item.influenceId);
      arr[index].alls.push(item);
      props.handleOutcomeListRemove("INFLUENCE", item._id);
    } else if (
      item.reflectiveId &&
      !arr[index].reflectiveIds.includes(item.reflectiveId)
    ) {
      arr[index].reflectiveIds.push(item.reflectiveId);
      arr[index].reflectives.push(item);
      arr[index].allIds.push(item.reflectiveId);
      arr[index].alls.push(item);
      props.handleOutcomeListRemove("REFLECTIVE", item._id);
    }

    const otherCat = arr?.map((element, index) => {
      if (element?.categoryId !== categoryId) {
        if (Boolean(item?.outcomeId)) {
          let newOutcomeIdsList, newOutcomesList;
          if (element?.outcomeIds?.includes(item?.outcomeId)) {
            newOutcomeIdsList = element?.outcomeIds?.filter((outcomeId) => {
              return outcomeId !== item?.outcomeId;
            });
            newOutcomesList = element?.outcomes?.filter((outcome) => {
              return outcome?.outcomeId !== item?.outcomeId;
            });
          } else {
            newOutcomeIdsList = element?.outcomeIds;
            newOutcomesList = element?.outcomes;
          }
          return {
            ...element,
            outcomeIds: newOutcomeIdsList,
            outcomes: newOutcomesList,
          };
        } else if (Boolean(item?.influenceId)) {
          let newInfluenceIdsList, newInfluenceList;
          if (element?.influenceIds?.includes(item?.influenceId)) {
            newInfluenceIdsList = element?.influenceIds?.filter(
              (influenceId) => {
                return influenceId !== item?.influenceId;
              }
            );
            newInfluenceList = element?.influences?.filter((influences) => {
              return influences?.influenceId !== item?.influenceId;
            });
          } else {
            newInfluenceIdsList = element?.influenceIds;
            newInfluenceList = element?.influences;
          }
          return {
            ...element,
            influenceIds: newInfluenceIdsList,
            influences: newInfluenceList,
          };
        } else if (Boolean(item?.reflectiveId)) {
          let newReflectiveIdsList, newReflectiveList;
          if (element?.reflectiveIds?.includes(item?.reflectiveId)) {
            newReflectiveIdsList = element?.reflectiveIds?.filter(
              (reflectiveId) => {
                return reflectiveId !== item?.reflectiveId;
              }
            );
            newReflectiveList = element?.reflectives?.filter((reflectives) => {
              return reflectives?.reflectiveId !== item?.reflectiveId;
            });
          } else {
            newReflectiveIdsList = element?.reflectiveIds;
            newReflectiveList = element?.reflectives;
          }
          return {
            ...element,
            reflectiveIds: newReflectiveIdsList,
            reflectives: newReflectiveList,
          };
        } else {
          return element;
        }
      } else {
        return element;
      }
    });
    // console.log(">>>>>>",otherCat)
    setAddCategoryList(otherCat);
  };

  const handleRename = (newValue: string, categoryId: string) => {
    if (newValue.trim() !== "")
      setAddCategoryList((prevState) => {
        const index = prevState.findIndex(
          (category) => category.categoryId === categoryId
        );
        prevState[index].name = newValue;
        return prevState;
      });
  };

  const handleChangeIcon = (newValue: {
    selectedTab: string;
    selectedIcon: any;
  }, categoryId: string) => {
    setAddCategoryList((prevState) => {
      const index = prevState.findIndex(
        (category) => category.categoryId === categoryId
      );
      prevState[index].iconUrl = newValue.selectedIcon;
      prevState[index].iconType = newValue.selectedTab;
      return prevState;
    });
  };
  const handleCloseDelete = () => {
    setShowDeleteConfirmation(false)
    setSelectedCategoryId(null)
  }
  const handleDelete = (id: string, confirmed = false) => {
    if (confirmed && selectedCategoryId) {
      categoryService
        .deleteCategory(outcomeState.token, selectedCategoryId)
        .then((res) => {
          let arr = [...addCategoryList];
          const index = arr.findIndex((category) => category._id === selectedCategoryId);
          arr.splice(index, 1);
          setAddCategoryList(arr);
          handleCloseDelete()
          setShowSnakbar(true);
          setSnakbarMsg(res?.description);
          props.setIsApiCall(!props.isApiCall);
        })
        .catch((error) => {
          setShowLoader(false);
          setShowSnakbar(true);
          setSnakbarMsg(
            error?.response?.data?.description
              ? error?.response?.data?.description
              : error.message
          );
          setMsgType("error");
          console.log("Delete category error", error);
        });
    } else {
      setShowDeleteConfirmation(true)
      setSelectedCategoryId(id)
    }
  };

  const handleDeleteItem = (categoryId: string, id: string, type: string) => {
    let arr = [...addCategoryList];
    let category = arr.find((obj) => obj.categoryId === categoryId);

    if (type === "OUTCOME") {
      const item = category.alls.find((obj) => obj.outcomeId === id);
      category.allIds = category.allIds.filter((e) => e !== id);
      category.alls = category.alls.filter((e) => e.outcomeId !== id);
      category.outcomeIds = category.outcomeIds.filter((e) => e !== id);
      category.outcomes = category.outcomes.filter((e) => e.outcomeId !== id);
      props.handleOutcomeListAdd("OUTCOME", item);
    } else if (type === "INFLUENCE") {
      const item = category.alls.find((obj) => obj.influenceId === id);
      category.allIds = category.allIds.filter((e) => e !== id);
      category.alls = category.alls.filter((e) => e.influenceId !== id);
      category.influenceIds = category.influenceIds.filter((e) => e !== id);
      category.influences = category.influences.filter(
        (e) => e.influenceId !== id
      );
      props.handleOutcomeListAdd("INFLUENCE", item);
    } else if (type === "REFLECTIVE") {
      const item = category.alls.find((obj) => obj.reflectiveId === id);
      category.allIds = category.allIds.filter((e) => e !== id);
      category.alls = category.alls.filter((e) => e.reflectiveId !== id);
      category.reflectiveIds = category.reflectiveIds.filter((e) => e !== id);
      category.reflectives = category.reflectives.filter(
        (e) => e.reflectiveId !== id
      );
      props.handleOutcomeListAdd("REFLECTIVE", item);
    }

    setAddCategoryList(arr);
  };

  const handleMoveMetricLocal = (
    sourceCategoryId: string,
    targetCategoryId: string,
    metricType: "outcome" | "influence" | "reflective",
    metricId: string
  ) => {
    if (!metricId || !sourceCategoryId || !targetCategoryId) return;
    if (String(sourceCategoryId) === String(targetCategoryId)) return;

    const listKey =
      metricType === "outcome"
        ? "outcomes"
        : metricType === "influence"
          ? "influences"
          : "reflectives";
    const idsKey =
      metricType === "outcome"
        ? "outcomeIds"
        : metricType === "influence"
          ? "influenceIds"
          : "reflectiveIds";
    const matchKey =
      metricType === "outcome"
        ? "outcomeId"
        : metricType === "influence"
          ? "influenceId"
          : "reflectiveId";

    setAddCategoryList((prevState) => {
      if (!Array.isArray(prevState) || !prevState.length) return prevState;

      const sourceCategory = prevState.find(
        (cat) =>
          String(cat?.categoryId ?? cat?._id) === String(sourceCategoryId)
      );
      if (!sourceCategory) return prevState;

      const matchesItem = (it: any) =>
        it &&
        String(it?.[matchKey] ?? it?._id ?? it?.uid) === String(metricId);

      const movedItem = (sourceCategory[listKey] || []).find(matchesItem);
      if (!movedItem) return prevState;

      const movedItemPrimaryId =
        movedItem?.[matchKey] ?? movedItem?._id ?? movedItem?.uid;

      return prevState.map((category) => {
        const catId = String(category?.categoryId ?? category?._id);

        if (catId === String(sourceCategoryId)) {
          return {
            ...category,
            [listKey]: (category[listKey] || []).filter(
              (it: any) => !matchesItem(it)
            ),
            [idsKey]: (category[idsKey] || []).filter(
              (id: string) => String(id) !== String(movedItemPrimaryId)
            ),
            alls: (category.alls || []).filter(
              (it: any) =>
                !(
                  it &&
                  (String(it?.[matchKey] ?? "") ===
                    String(movedItemPrimaryId) ||
                    (movedItem?._id && it?._id === movedItem?._id))
                )
            ),
            allIds: (category.allIds || []).filter(
              (id: string) => String(id) !== String(movedItemPrimaryId)
            ),
          };
        }

        if (catId === String(targetCategoryId)) {
          const existingIds = (category[idsKey] || []).map(String);
          if (existingIds.includes(String(movedItemPrimaryId))) {
            return category;
          }
          return {
            ...category,
            [listKey]: [...(category[listKey] || []), movedItem],
            [idsKey]: [...(category[idsKey] || []), movedItemPrimaryId],
            alls: [...(category.alls || []), movedItem],
            allIds: [...(category.allIds || []), movedItemPrimaryId],
          };
        }

        return category;
      });
    });
  };

  const moveCategoryItem = (dragIndex, hoverIndex) => {
    if (dragIndex !== undefined && hoverIndex !== undefined) {
      // const dragEle = addCategoryList.filter((ele)=> {
      //   return ele.order === dragIndex
      // })
      // console.log("dragEle,dragEle",dragEle)
      let dragItem = addCategoryList[dragIndex];
      let hoverItem = addCategoryList[hoverIndex];
      const updatedCategoryArray = [...addCategoryList].filter(
        (ele) => ele !== undefined
      );
      if (dragIndex !== hoverIndex) {
        dragItem = {
          ...dragItem,
          order: hoverIndex,
          arrayIndex: hoverIndex,
        };
        hoverItem = {
          ...hoverItem,
          order: dragIndex,
          arrayIndex: dragIndex,
        };
        updatedCategoryArray[dragIndex] = hoverItem;
        updatedCategoryArray[hoverIndex] = dragItem;
      }
      setAddCategoryList(updatedCategoryArray);
    }
  };
  return (
    <RootStyle>
      {/* SNACK BAR */}
      <SnackBarComp
        showSnakbar={showSnakbar}
        handleCloseSnakbar={handleCloseSnakbar}
        snakbarMsg={snakbarMsg}
        type={msgType ? msgType : "info"}
      />
      <Typography
        variant="h1"
        component="h1"
        className={classes.registrationHeading}
        style={{...(isDarkMode ? { color: "var(--color-text-primary)" } : {}),}}
      >
        Organize your metrics in your own way
      </Typography>
      <Typography variant="h4" component="h4" className={classes.pageTitle} style={{...(isDarkMode ? { color: "var(--color-text-primary)" } : {}),}}>
        Create a structure for your metrics that mirrors how you think about
        your life and the different areas you are working on.
      </Typography>
      <Grid display="flex" alignItems="center" flexWrap="wrap">
        <Typography variant="caption" component="div" style={{...(isDarkMode ? { color: "var(--color-text-primary)" } : {}),}}>
          Create Category
        </Typography>
        <Grid
          display="flex"
          alignItems="center"
          sx={{ cursor: "pointer", ml: "32px" }}
          onClick={() => showDrawer()}
        >
          <GetIdeasIcon />
          <span className={classes.needSomeIdeas}>Need some ideas?</span>
        </Grid>
        {/* RIGHT SIDE DRAWER */}
        <IdeasDrawer
          openDrawer={openDrawer}
          closeDrawer={closeDrawer}
          categoryIdeas={props.categoryIdeas}
          setCategoryInput={(idea) => {
            setCategoryInput(idea.name);
          }}
          isDarkMode={isDarkMode}
        />
      </Grid>

      <Grid
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="nowrap"
        gap={"12px"}
      >
        <TextField
          className="fillTextInput fullWidth"
          placeholder="Add an category to group your metrics"
          variant="outlined"
          fullWidth
          name="influence"
          value={categoryInput || ""}
          onChange={(e) => handleChangeCategory(e)}
          sx={{ mt: 2.5, flex: "auto",
            "& .MuiOutlinedInput-root": {
              ...(isDarkMode ? { background: "var(--white-background) !important" } : {}),
            },
           }}
        />
        <Box sx={{ mt: 2.5, flex: "auto" }}>
          <NewButton
            variant="contained"
            buttonText={"Create"}
            onClick={handleCreate}
            isLoadong={showLoader}
            isDisabled={!categoryInput || categoryInput.trim() === ""}
            padding="0px 34px"
            boxPadding="14px 16px"
          />
        </Box>
      </Grid>

      {!!addCategoryList.length && (
        <Grid>
          <Box
            display={"flex"}
            alignItems={"center"}
            alignSelf={"stretch"}
            justifyContent={"center"}
            sx={{ mt: 6 }}
          >
            <Box
              display={"inline-flex"}
              alignItems={"center"}
              sx={{
                // background: "#EBF2F1",
                gap: "6px",
              }}
            >
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"flex-end"}
                id={"mode-switch-tab"}
                sx={{
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setexpandedView(true);
                  setExpandList([]);
                  // trackingDispatch(setExpandView(true))
                  // setExpandedLevelView(false)
                  // userTypeDispatch(addCategoryExpandAction([]))
                }}
              >
                <Box
                  sx={{
                    borderRadius: "4px",
                    backgroundColor:
                      /* expandedView ? palette.primary.main : */ "transparent",
                    borderBottom: expandedView
                      ? `2px solid ${palette.primary.main}`
                      : "none",
                    borderBottomLeftRadius: "0px",
                    borderBottomRightRadius: "0px",
                  }}
                >
                  <Box
                    sx={{
                      borderRadius: "6px",
                      padding: "0px 12px",
                    }}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    <Typography
                      variant="body2"
                      component="span"
                      className={classes.compactExpandColumntab}
                      sx={{
                        fontWeight: expandedView
                          ? "700 !important"
                          : "400 !important",
                          ...(isDarkMode ? { color: "var(--color-text-primary)" } : {}),
                      }}
                    >
                      Compact
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"flex-end"}
                sx={{
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setexpandedView(false);
                  if (addCategoryList && addCategoryList.length) {
                    let arr = [];
                    for (
                      let index = 0;
                      index < addCategoryList.length;
                      index++
                    ) {
                      const element = addCategoryList[index];
                      arr.push(element.categoryId);
                    }
                    setExpandList(arr);
                  }
                  // setExpandedLevelView(false)
                  // trackingDispatch(setExpandView(false))
                }}
              >
                <Box
                  sx={{
                    borderRadius: "4px",
                    backgroundColor:
                      /* !expandedView ? palette.primary.main : */ "transparent",
                    borderBottom: !expandedView
                      ? `2px solid ${palette.primary.main}`
                      : "none",
                    borderBottomLeftRadius: "0px",
                    borderBottomRightRadius: "0px",
                  }}
                >
                  <Box
                    sx={{
                      borderRadius: "6px",
                      padding: "0px 12px",
                    }}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    <Typography
                      variant="body2"
                      component="span"
                      className={classes.compactExpandColumntab}
                      sx={{
                        fontWeight: !expandedView
                          ? "700 !important"
                          : "400 !important",
                          ...(isDarkMode ? { color: "var(--color-text-primary)" } : {}),
                      }}
                    >
                      Expanded
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            display={"flex"}
            alignItems={"center"}
            alignSelf={"stretch"}
            justifyContent={"space-between"}
            sx={{ mt: 6 }}
          >
            <Typography variant="caption" component="div" style={{...(isDarkMode ? { color: "var(--color-text-primary)" } : {}),}}>
              Drag from the right panel and drop here
            </Typography>
          </Box>

          <Grid container sx={{ mt: 2 }} justifyContent="space-between">
            {addCategoryList.map((category, index) => {
              return (
                <CategoryItemWrapper
                  index={index}
                  key={category?.categoryId}
                  category={category}
                  addItem={(item) => handleAdd(category?.categoryId, item)}
                  onRenameCategory={handleRename}
                  handleChangeIcon={handleChangeIcon}
                  onDelete={handleDelete}
                  onDeleteItem={handleDeleteItem}
                  // movePetListItem={movePetListItem}
                  setAddCategoryList={setAddCategoryList}
                  addCategoryList={addCategoryList}
                  moveCategoryItem={moveCategoryItem}
                  expandedList={expandedList}
                  expanded={expanded}
                  isDarkMode={isDarkMode}
                  journeyCategoryList={addCategoryList || []}
                  token={outcomeState?.token}
                  restricted={outcomeState?.restrictUser}
                  onRestricted={() =>
                    userTypeDispatch(setOpenSubscriptionModal(true))
                  }
                  callservice={() =>
                    props.setIsApiCall && props.setIsApiCall(!props.isApiCall)
                  }
                  trackingDispatch={trackingDispatch}
                  onLocalMove={handleMoveMetricLocal}
                />
              );
            })}
          </Grid>
        </Grid>
      )}
      <Dialog
        open={showDeleteConfirmation}
        onClose={handleCloseDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={`${classes.categoryDialog} dialogWrapper-mobileScreen`}
        sx={
          {
            "& .MuiPaper-root": {
              padding: "0px !important",
              borderRadius: "12px",
              gap: "24px",
              background: "#FFF",
              "@media  (max-width: 5000px)": {
                padding: "32px 24px !important",
                gap: "16px",
                borderRadius: !isMobile ? "12px !important" : "12px 12px 0px 0px !important",
                display: "flex",
                flexDirection: "column",
                height: "max-content",
                maxHeight: "calc(100vh - 5%)",
                width: !isMobile ? "360px" : "100%",
              },
              // position: 'relative'
            },
          }
        }
      >
        <DialogContent id="alert-dialog-description">
          <div
            style={{
              display: "flex",
              padding: isMobile ? "0px !important" : "0px",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "16px",
              alignSelf: "stretch",
            }}
            className={classes.paddingClassMobile}
          >
            <CommonTypo size={24} fontWeight={700} color="var(--color-text-primary)" lineHeight={28.8}>
              {"You sure you want to remove the category?"}</CommonTypo>
            <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)" lineHeight={25.6}>
              {"You can not restore it after this action"}</CommonTypo>
          </div>
        </DialogContent>
        <DialogActions className={classes.categoryDialogAction}>
          <NewButton
            buttonText={"Back"}
            variant="outlined"
            extraSx={{
              width: "100%",
              background: "var(--color-border)",
              border: `none`,
              height: "40px"
            }}
            typographySx={{
              "&.MuiTypography-root": {
                "@media  (max-width: 726px) and (min-width: 100px)": {
                  fontSize: `${pxToRem(16)} !important`,
                  lineHeight: "100% !important",
                  fontWeight: 600,
                  color: "var(--color-text-primary)"
                },
              },
            }}
            onClick={handleCloseDelete}
          />
          <NewButton
            buttonText={"Remove"}
            variant="contained"
            onClick={() => {
              handleDelete(null, true)
            }}
            extraSx={{
              width: "100%",
              background: "#FF5555",
              border: `none`,
              height: "40px"
            }}
            typographySx={{
              "&.MuiTypography-root": {
                "@media  (max-width: 786px) and (min-width: 100px)": {
                  fontSize: `${pxToRem(16)} !important`,
                  lineHeight: "100% !important",
                  fontWeight: 600,
                  color: "var(--color-text-primary)"
                },
              },
            }}
          />
        </DialogActions>
      </Dialog>
    </RootStyle>
  );
};

export default LeftSideCategory;
